module.exports = __webpack_public_path__ + "img/discover_world_map.d492781.webp";